import hyperdom from 'hyperdom'
import pastGuestBenefitSchema from './pastGuestBenefitSchema.js'
import SectionComponentBase from './sectionComponentBase.jsx'
import DeclarationVerificationBanner from './declarationVerificationBanner.jsx'

export default class PastGuestBenefit extends SectionComponentBase {
  constructor ({config, quoteCriteria, user}) {
    super({sectionName: 'past-guest'})
    this.config = config
    this.schema = pastGuestBenefitSchema({
      config: this.config,
    })
    this.declarationVerificationBanner = new DeclarationVerificationBanner({config})
    this.quoteCriteria = quoteCriteria
    this.user = user
  }

  removeReferralPromoIfNecessary () {
    if(this.quoteCriteria.passengers.filter(p => p.pastGuestBenefit?.selected === true).length === this.quoteCriteria.passengers.length) {
      this.quoteCriteria.removeReferralPromo()
    }
  }

  render () {
    return <div className='past-passenger-discount'>
      <div className='o-accent-box'>
        {this.renderHeader()}
        {this.renderMobile()}
        {this.renderValidationError(this.quoteCriteria, 'pastGuestBenefit')}
      </div>
    </div>
  }

  renderMobile () {
    return [
      this.renderRadioButtons({
        onNoClick: () => {
          this.quoteCriteria.passengers.forEach(p => delete p.pastGuestBenefit.selected)
        },
      }),
      this.renderPassengersList(),
    ]
  }

  renderHeader () {
    const subtitleText = this.user.whitelabel
      ? `Have any of the guests ${this.config.localisedWords.travelled || 'travelled'} 4 or more times with the Travel Corporation family of brands before?`
      : `Have any of the guests ${this.config.localisedWords.travelled} 4 or more times with ${this.config.brandFamilyDisplayText} or other brands of the Travel Corporation family of brands before?`
    return [
      <p className='discounts-offers__title'>Past Guest Benefit
        <span className='travel-protection-tooltip tooltip'>
          <div className='tooltip__content'>If you have previously {this.config.localisedWords.travelled} with one of The Travel Corporation (TTC) brands, you may be eligible for special benefits and offers on your booking. Here are the qualifying brands: Trafalgar, Costsaver, Insight Vacations, Luxury Gold, Contiki, Brendan Vacations, AAT Kings, Inspiring Journeys.
          </div>
        </span>
      </p>,
      <p className='discounts-offers__subtitle'>{subtitleText}</p>,
    ]
  }

  renderPassengersList () {
    return <div className={`past-passenger-discount__passengers ${this.toggledForMobile ? 'show' : ''}`}>
      {this.quoteCriteria.passengers.map((passenger, index) => {
        return <div className='past-passenger-discount__passenger'>
          <div className={`past-passenger-discount__passenger-info past-passenger-discount__passenger-info-${index}`}>
            <label for={`passenger-ftd-${index}`} className='o-choice-item -fullWidth u-margin-bottom-none'>
              <input id={`passenger-ftd-${index}`} type='checkbox' className='o-choice-item__checkbox' binding={[passenger.pastGuestBenefit, 'selected']} onchange={() => {this.removeReferralPromoIfNecessary()}}/>
              <div className='o-choice-item__content'>
                <span className={index === 0 ? 'passenger-name-semibold' : 'passenger-name'}>{passenger.fullName()}{index === 0 ? ` (Lead Passenger)` : ``}</span>
              </div>
            </label>
            <div className={['flights__search-container', {'show-expanded': passenger.pastGuestBenefit.selected}]}>
              <div className='past-guest-benefit-message message-info -strong'>
                <strong>Thank you for {this.config.localisedWords.travelling} with us again!</strong>
                <div>To show our appreciation, please enjoy an exclusive 5% discount on this trip. Please continue with your booking and one of our team members will verify and apply the discount after checkout.</div>
              </div>
            </div>
          </div>
          {this.declarationVerificationBanner}
        </div>
      })}
    </div>
  }
}
